
import Form from 'components/Form'
import TextArea from 'components/Fields/TextArea'

import validators from 'utils/validators'
import useTranslate from '../../hooks/useTranslate'

const validationSchema = validators.object({
  name: validators.requiredString(),
  email: validators.email(),
  message: validators.requiredString()
})

const defaultFieldSchema = [
  {
    name: 'name',
    label: 'CONTACT_US_FORM_NAME',
    required: true,
    hidePlaceholder: true,
    autoComplete: 'name'
  },
  {
    name: 'email',
    label: 'CONTACT_US_FORM_EMAIL',
    type: 'email',
    required: true,
    hidePlaceholder: true,
    autoComplete: 'email'
  },
  {
    name: 'message',
    label: 'CONTACT_US_FORM_MESSAGE',
    required: true,
    hidePlaceholder: true,
    component: TextArea
  }
]

const ContactUsForm = (props) => {
  const { onSubmit } = props
  const translate = useTranslate()

  const handleSubmit = React.useCallback((values) => {
    onSubmit && onSubmit(values)
  }, [])

  const formProps = {
    onSubmit: handleSubmit,
    buttonLabel: translate('BUTTON_LABEL_SUBMIT'),
    fieldSchema: defaultFieldSchema,
    validationSchema
  }
  return (
    <Form {...formProps} />
  )
}

export default ContactUsForm
